export default {
  DASHBOARD: 'dashboard',
};
